/**
 * @module booking.service
 */
import { DialVerseApi } from '../app/api'
import AppConfig from '../config'

const BookingService = DialVerseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Basic CRUD operations
    getBookings: builder.mutation({
      query: (params = {}) => ({
        url: AppConfig.getUrl('/bookings'),
        method: 'GET',
        params,
      }),
    }),
    getBooking: builder.mutation({
      query: (bookingId) => ({
        url: AppConfig.getUrl(`/bookings/${bookingId}`),
        method: 'GET',
      }),
    }),
    createBooking: builder.mutation({
      query: (bookingData) => ({
        url: AppConfig.getUrl('/bookings'),
        method: 'POST',
        body: bookingData,
      }),
    }),
    updateBooking: builder.mutation({
      query: ({ bookingId, ...bookingData }) => ({
        url: AppConfig.getUrl(`/bookings/${bookingId}`),
        method: 'PUT',
        body: bookingData,
      }),
    }),
    deleteBooking: builder.mutation({
      query: (bookingId) => ({
        url: AppConfig.getUrl(`/bookings/${bookingId}`),
        method: 'DELETE',
      }),
    }),

    // Booking-specific operations
    confirmBooking: builder.mutation({
      query: (bookingId) => ({
        url: AppConfig.getUrl(`/bookings/${bookingId}/confirm`),
        method: 'PATCH',
      }),
    }),
    cancelBooking: builder.mutation({
      query: (bookingId) => ({
        url: AppConfig.getUrl(`/bookings/${bookingId}/cancel`),
        method: 'PATCH',
      }),
    }),
    processPayment: builder.mutation({
      query: ({ bookingId, ...paymentData }) => ({
        url: AppConfig.getUrl(`/bookings/${bookingId}/payment`),
        method: 'PATCH',
        body: paymentData,
      }),
    }),
    updatePaymentStatus: builder.mutation({
      query: ({ bookingId, paymentStatus }) => ({
        url: AppConfig.getUrl(`/bookings/${bookingId}/payment-status`),
        method: 'PATCH',
        body: { paymentStatus },
      }),
    }),
    updateTransactionStatus: builder.mutation({
      query: ({ bookingId, transactionStatus }) => ({
        url: AppConfig.getUrl(`/bookings/${bookingId}/transaction-status`),
        method: 'PATCH',
        body: { transactionStatus },
      }),
    }),

    // Passenger and Flight related routes
    getBookingsByPassenger: builder.mutation({
      query: ({ passengerId, ...params }) => ({
        url: AppConfig.getUrl(`/bookings/passenger/${passengerId}`),
        method: 'GET',
        params,
      }),
    }),
    getBookingsByFlight: builder.mutation({
      query: ({ flightId, ...params }) => ({
        url: AppConfig.getUrl(`/bookings/flight/${flightId}`),
        method: 'GET',
        params,
      }),
    }),
    getActiveBookings: builder.mutation({
      query: (params = {}) => ({
        url: AppConfig.getUrl('/bookings/active'),
        method: 'GET',
        params,
      }),
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetBookingsMutation,
  useGetBookingMutation,
  useCreateBookingMutation,
  useUpdateBookingMutation,
  useDeleteBookingMutation,
  useConfirmBookingMutation,
  useCancelBookingMutation,
  useProcessPaymentMutation,
  useUpdatePaymentStatusMutation,
  useUpdateTransactionStatusMutation,
  useGetBookingsByPassengerMutation,
  useGetBookingsByFlightMutation,
  useGetActiveBookingsMutation,
} = BookingService
